 
import { Component, OnInit } from '@angular/core';

import { UserService } from '../services/user.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { RequestChangePassword } from '../models/requestChangePassword';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-changePass',
  templateUrl: './changePass.component.html'
})


export class ChangePassComponet implements OnInit {

  constructor(private translate: TranslateService, public service: UserService, private toastr: ToastrService, private authService: AuthService, private spinner: NgxSpinnerService) { }
  requestChangePassword = new RequestChangePassword();

  ngOnInit() {

    
  }




  onSubmit(form: NgForm) {
    form.value.logUser = this.authService.getLoginFromToken();

    this.spinner.show();
    this.service.changePassword(form.value).subscribe(
      res => {
        this.resetForm(form);
        this.toastr.success(this.translate.instant("COM.true"), '');
        this.spinner.hide();
      },
      err => {       
        this.spinner.hide();
      }
    )
 
  }

  resetForm(form: NgForm) {
    form.resetForm();
  }



}
